var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    attrs: {
      "defaultValues": {
        search: ''
      }
    },
    on: {
      "submit": function($event) {
        _vm.$emit('search', $event.search.trim())
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('v-row', {
          attrs: {
            "align-items": "end"
          }
        }, [_c('v-col', {
          attrs: {
            "xs": "7"
          }
        }, [_c('v-form-input', {
          attrs: {
            "field": "search",
            "label": "Поиск по ФИО, названию организации, ИНН, ОГРН"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs": "5"
          }
        }, [_c('v-button', {
          attrs: {
            "type": "submit",
            "flat": "",
            "primary": ""
          }
        }, [_vm._v("\n                    найти\n                ")])], 1)], 1)]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45029580","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requests/FormSearch.vue
// module id = 877
// module chunks = 0